<template>
  <div class="layout-content-list">
    <el-breadcrumb separator=">" class="bc-nav">
      <el-breadcrumb-item :to="{ path: '/walletindex' }">
        <i class="iconfont icon_home icon-t-1"></i>
        <span>钱包</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>支付未完成</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="toolbar-wrap">
      <div class="toolbar-item" id="auto-0">
        <span class="demonstration">时间段</span>
        <el-select class="short" v-model="tableOptions.dateType" placeholder="请选择">
          <el-option v-for="item in selectOption" :label="item.label" :value="item.value" :key="item.value">
          </el-option>
        </el-select>
        <el-date-picker
          v-model="tableOptions.startTime"
          type="datetime"
          placeholder="选择开始时间"
          :clearable="false"
          value-format="timestamp"
          :picker-options="pickerTime"
        >
        </el-date-picker>
        <span>-</span>
        <el-date-picker
          v-model="tableOptions.endTime"
          type="datetime"
          placeholder="选择结束时间"
          default-time="23:59:59"
          :clearable="false"
          value-format="timestamp"
          :picker-options="pickerTime"
        >
        </el-date-picker>
      </div>

      <div class="toolbar-item" id="auto-1">
        <el-popover
          ref="popover1"
          placement="top-start"
          width="240"
          trigger="focus"
          content="请输入单号，车牌，司机，收单员，货物类型"
        >
        </el-popover>
        <span class="demonstration">其他</span>
        <el-input
          class="long"
          v-model.trim="tableOptions.keyword"
          v-popover:popover1
          placeholder="请输入单号，车牌，司机，收单员，货物类型"
        >
        </el-input>
      </div>
      <div class="toolbar-item" id="auto-2">
        <span class="demonstration">支付状态</span>
        <el-select v-model="tableOptions.payState" placeholder="请选择" class="track-elselect">
          <el-option v-for="item in payStateList" :label="item.label" :value="item.value" :key="item.value">
          </el-option>
        </el-select>
      </div>
      <CarrierCompany ref="carrierCompany" @changeValue="changeItem('taxConnRelation', ...arguments)"></CarrierCompany>
      <div class="toolbar-item" id="auto-4">
        <span class="demonstration">运单类型</span>
        <el-select v-model="tableOptions.orderType" placeholder="请选择" class="track-elselect">
          <el-option v-for="item in orderTypeList" :label="item.label" :value="item.value" :key="item.value">
          </el-option>
        </el-select>
      </div>
      <div class="toolbar-item">
        <el-button class="custom-search-btn" @click="screen" id="auto-5">筛选</el-button>
      </div>
    </div>
    <div class="btn-group-box clearfix">
      <div class="fl">
        <span class="btn-left-txt"> 支付失败列表 </span>
      </div>
      <div class="fr"></div>
    </div>
    <div class="table-custom-box" id="auto-7">
      <fe-table
        :tableData="tableData"
        :columns="columns"
        border
        :show-pagination="true"
        :pagination-config="pagination"
        @pagination-current-change="handleCurrentChange"
        @pagination-size-change="handleSizeChange"
      >
        <template #expand>
          <el-table-column type="expand">
            <template v-slot="props">
              <el-form label-position="left" inline class="self-table-expand">
                <el-form-item label="收单点">
                  <span>{{ props.row.signSiteName }}</span>
                </el-form-item>
                <el-form-item label="实发数量">
                  <span>{{ props.row.originalUnit }}吨</span>
                </el-form-item>
                <el-form-item label="实收数量">
                  <span>{{ props.row.actualUnit }}吨</span>
                </el-form-item>
                <el-form-item label="下单运费">
                  <span>{{ props.row.freightRates | thousands(2) }}元</span>
                </el-form-item>
                <el-form-item label="已付金额">
                  <span>{{ props.row.alreadyPay | thousands(2) }}元</span>
                </el-form-item>
                <el-form-item label="应付调度费">
                  <span>{{ props.row.scheduleFee | thousands(2) }}元</span>
                </el-form-item>
                <el-form-item label="应付平台服务费">
                  <span>{{ props.row.poundage | thousands(2) }}元</span>
                </el-form-item>
                <el-form-item label="承运司机">
                  <span>{{ props.row.driverName }}</span>
                </el-form-item>
                <el-form-item label="司机手机号">
                  <span>{{ props.row.driverPhone }}</span>
                </el-form-item>
              </el-form>
            </template>
          </el-table-column>
        </template>
        <!-- 运单号 -->
        <template #orderNumber="{ scope }">
          <div class="font-blue pointer" @click="showDetail(scope.row)">
            {{ scope.row.orderNumber }}
          </div>
          <div class="new-yellow-tag" v-if="scope.row.yellowOrder"></div>
        </template>
        <!-- 应付运费 -->
        <template #actualPay="{ scope }">
          <span>{{ scope.row.actualPay | thousands(2) }}</span>
        </template>
        <!-- 应付合计 -->
        <template #actualSum="{ scope }">
          <span>{{ scope.row.actualSum | thousands(2) }}</span>
        </template>
        <!-- 下单日期 -->
        <template #createDate="{ scope }">
          <span> {{ scope.row.createDate | stamp2TextDate }}</span>
        </template>
        <!-- 收单日期 -->
        <template #signDate="{ scope }">
          <span> {{ scope.row.signDate | stamp2TextDate }}</span>
        </template>
        <!-- 复核时间 -->
        <template #orderCheckDate="{ scope }">
          <span> {{ scope.row.orderCheckDate | stamp2TextDateFull(2) }}</span>
        </template>
        <!-- 操作 -->
        <template #handle="{ scope }">
          <span
            class="font-green pointer"
            v-if="(scope.row.payState == 1 || scope.row.payState == 4) && roleRules.indexOf('SJB_P_0023') != -1"
            @click="pay(scope.row)"
            >支付</span
          >
        </template>
      </fe-table>
    </div>
    <!-- 验证支付密码dialog 可复制公用 -->
    <el-dialog
      title="提示"
      :visible.sync="pwdDialog.visible"
      :before-close="beforeClose"
      custom-class="pay-custom-dialog"
    >
      <p class="pb-5">请输入支付密码</p>
      <el-input
        v-model.trim="pwdDialog.password"
        type="text"
        @focus="clearInput"
        :maxlength="6"
        placeholder="请输入支付密码"
        name="passtext"
      ></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="beforeClose">取消</el-button>
        <el-button type="primary" @click="confirmPay"> 确定 </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
/**
 * 自动化测试id
 * 当前最大值为:7
 * @param {int} max id最大值
 * 每次变更累加 请手动更新
 * 示例：auto-0
 */
import { WUYI, vali } from '@/api/common';
import axios from '@/api/axiosNew';
import api from '@/api/base.new.api';
import dateLimit from '@/api/dateLimit';
import tableMixin from '@/utils/tableMixin';
import { getPublicKey } from '@/utils';
import CarrierCompany from '@/components/CarrierCompany.vue';
import { isPayPwd } from '@fe/validator';
import JSEncrypt from 'jsencrypt';
export default {
  name: 'PayFailedList',
  mixins: [tableMixin],
  components: {
    CarrierCompany
  },
  data() {
    return {
      columns: [
        { label: '运单号', prop: 'orderNumber', 'min-width': 200 },
        { label: '承运公司', prop: 'haulageOperatorName', 'min-width': 160 },
        { label: '支付状态', prop: 'payStateDesc', 'min-width': 75 },
        { label: '车牌号码', prop: 'licencePlate', 'min-width': 105 },
        { label: '货物类型', prop: 'stockKind', 'min-width': 90 },
        { label: '应付运费(元)', prop: 'actualPay', 'min-width': 100 },
        { label: '应付合计(元)', prop: 'actualSum', 'min-width': 100 },
        { label: '发货单号', prop: 'stockOrder', 'min-width': 100 },
        { label: '装货地', prop: 'loadAddress', 'min-width': 100 },
        { label: '卸货地', prop: 'unloadAddress', 'min-width': 100 },
        { label: '货源备注', prop: 'stockDesc', 'min-width': 100 },
        { label: '收单员', prop: 'signName', 'min-width': 100 },
        { label: '下单日期', prop: 'createDate', 'min-width': 100 },
        { label: '收单日期', prop: 'signDate', 'min-width': 100 },
        { label: '复核时间', prop: 'orderCheckDate', width: 130 },
        { label: '操作', prop: 'handle', 'min-width': 100, fixed: 'right' }
      ],
      tableOptions: {
        startTime: new Date(dateLimit.getThreeMonth()).getTime(),
        endTime: dateLimit.currentDayEnd.getTime(),
        keyword: '',
        dateType: 1, // 日期类型 1下单日期 2复核日期
        taxConnRelation: '', // 承运公司编码
        payState: 0, // 支付状态 1待支付 2支付中 4支付失败
        orderType: 1 // 运单类型 1普通运单
      },
      axiosConfig: { url: api.payFailQryPayFailList }, // 列表接口
      roleRules: WUYI.currentData.userrole || [],
      pickerTime: {
        disabledDate: time => {
          if (time > dateLimit.currentDayEnd.getTime()) {
            return true;
          }
          return false;
        }
      },
      pwdDialog: {
        visible: false,
        password: ''
      },
      selectOption: [
        { label: '下单日期', value: 1 },
        { label: '复核日期', value: 2 }
      ],
      payStateList: [
        { label: '全部', value: 0 },
        { label: '支付处理中', value: 2 },
        { label: '支付失败', value: 4 }
      ],
      orderTypeList: [{ label: '普通运单（余额和平台账期支付）', value: 1 }],
      taxConnRelationList: [], // 承运公司列表
      currentOrderNum: ''
    };
  },
  activated() {
    this.screen();
  },
  methods: {
    //筛选查询
    screen() {
      if (!WUYI.checkDate(this.tableOptions.startTime, this.tableOptions.endTime)) return;
      this.handleSearch();
    },
    selectSourceCode(data) {
      this.tableOptions.sourceCode = data != null && data.regioncode ? data.regioncode : '';
    },
    selectTargetCode(data) {
      this.tableOptions.targetCode = data != null && data.regioncode ? data.regioncode : '';
    },
    // 重新支付
    pay(row) {
      this.$confirm('确定重新支付?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.currentOrderNum = row.orderNumber;
          this.pwdDialog.visible = true;
          this.pwdDialog.password = '';
        })
        .catch(() => {});
    },

    showDetail(row) {
      this.$router.push(`/acqcheckdetail/${row.orderNumber}/singleFail`);
    },
    // 屏蔽浏览器记住密码
    clearInput(event) {
      event.target.type = 'password';
    },
    beforeClose() {
      this.pwdDialog.visible = false;
      this.pwdDialog.password = '';
    },
    changeItem(key, val) {
      this.tableOptions[key] = val;
    },
    // 批量支付或单个支付
    async confirmPay() {
      if (!this.pwdDialog.password) {
        this.$message.error('请输入支付密码');
        return;
      }
      if (!isPayPwd(this.pwdDialog.password)) {
        this.$message.error('支付密码必须为6位数字');
        return;
      }
      let publicKeyData = await getPublicKey();
      let encrypt = new JSEncrypt();
      encrypt.setPublicKey(publicKeyData.publicKey);
      let postData = {
        payPassword: encrypt.encrypt(this.pwdDialog.password),
        secureKey: publicKeyData.secureKey,
        submitAll: false,
        orderNumberList: [this.currentOrderNum]
      };

      await axios.post(api.orderPayAgain, postData);
      this.screen();
      this.pwdDialog.visible = false;
    }
  }
};
</script>
<style>
.checkResult-custom-dialog {
  width: 460px;
}
</style>
